import React from 'react';

import useOverElement from 'hooks/useOverElement';
import { QuoteCMS } from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from './ArticleQuote.styles';

export interface ArticleQuoteProps {
  data: QuoteCMS;
}

const defaultProps: Partial<ArticleQuoteProps> = {};

const ArticleQuote: React.FunctionComponent<ArticleQuoteProps> = ({ data }) => {
  const [ref] = useOverElement();

  return (
    <S.ArticleQuoteWrapper ref={ref} type={data.width}>
      <S.Quote variant={data.variant}>“{data.quote}”</S.Quote>
      <S.Author>
        <p>{data.author}</p>
        <p>{data.description}</p>
      </S.Author>
    </S.ArticleQuoteWrapper>
  );
};

ArticleQuote.defaultProps = defaultProps;

export default ArticleQuote;
